var site = site || {};
var Mustache = Mustache || {};
var Model = Model || {};

(function($) {
  /**
    * The display class handles all the display options within inventory store locator.
    * This does NOT handle the diplay within the product pages; just within the application iteself.
  */
  site.display = function(args) {
    var _args = args || {};
    this.dom = {};
    this.container = _args.container || null;
    this.inlineTemplate = _args.inlineTemplate || 'product_store_check/display_inline';
    this.overlayTemplate = _args.overlayTemplate || 'product_store_check/display_overlay';
    this.eventNameSpace = 'display:';
    this.isLoaded = false;
    this.isMobile = false;
    this.activeSku = '';
    this.isOverlayOpen = false;
    this.hasDoors = false;
    this.hasInventory = false;
    this.useOverlay = false;
    this.animSpeed = 500;
    this.animType = 'swing';
    this.distanceVal = '';
    this.state = null;
    this.data = null;

    this.bindEvents();
  };

  /**
    * Method to get all DOM selectors when class is initialized.
    * All selectors should be placed here to keep everything located in one spot.
  */
  site.display.prototype.getNodes = function() {
    this.dom.$container = $('.js-store-check-inline');
    this.dom.$overlayContainer = $('.js-store-check-overlay');
  };

  /**
    * Method to set all bind events when class is initialized.
    * All bind events, including events from other panels, should be placed here.
  */
  site.display.prototype.bindEvents = function() {
    $(document).on(this.eventNameSpace + 'inline:init', $.proxy(this.init, this));
    $(document).on(this.eventNameSpace + 'inline:default', $.proxy(this.initDefault, this));
    $(document).on(this.eventNameSpace + 'inline:stores', $.proxy(this.initStores, this));
    $(document).on(this.eventNameSpace + 'inline:edit', $.proxy(this.initEdit, this));
    $(document).on(this.eventNameSpace + 'error:nodoors', $.proxy(this.initNoDoors, this));
    $(document).on(this.eventNameSpace + 'error:noskus', $.proxy(this.initNoSkus, this));
    $(document).on(this.eventNameSpace + 'overlay:init', $.proxy(this.initOverlay, this));
    $(document).on(this.eventNameSpace + 'overlay:use', $.proxy(this.setOverlayFlag, this));
    $(document).on(this.eventNameSpace + 'overlay:open', $.proxy(this.openOverlay, this));
    $(document).on(this.eventNameSpace + 'overlay:set', $.proxy(this.openOverlay, this));
    $(document).on(this.eventNameSpace + 'overlay:close', $.proxy(this.closeOverlay, this));
    $(document).on(this.eventNameSpace + 'state:set', $.proxy(this.setState, this));
    $(document).on(this.eventNameSpace + 'sku:set', $.proxy(this.onSkuChange, this));
    $(document).on(this.eventNameSpace + 'display:desktop', $.proxy(this.handleDesktopDisplay, this));
    $(document).on(this.eventNameSpace + 'display:mobile', $.proxy(this.handleMobileDisplay, this));
    $(document).on(this.eventNameSpace + 'render', $.proxy(this.render, this));
    $(document).on(this.eventNameSpace + 'renderDoors', $.proxy(this.renderDoors, this));
    $(document).on(this.eventNameSpace + 'reset', $.proxy(this.reset, this));
    $(document).on(this.eventNameSpace + 'loaded:set', $.proxy(this.setLoaded, this));
    $(document).on(this.eventNameSpace + 'loaded:unset', $.proxy(this.unsetLoaded, this));

    $(document).on('inStoreLocator:opened', $.proxy(this.init, this));
    $(document).on('inStoreLocator:reset', $.proxy(this.removeEvents, this));
    $(document).on('product.skuSelect', $.proxy(this.onSkuChange, this));
    $(document).on('controls:distance:change', $.proxy(this.setDist, this));
    $(document).on('inStoreLocator:device:set', $.proxy(this.setMobileFlag, this));
  };

  /**
    * Initialization method called when the locator is first displayed inline.
  */
  site.display.prototype.init = function(e, args) {
    var that = this;
    var _args = args || {};
    that.disableOverlay = _args.disableOverlay ? true : false;
    that.getNodes();
    that.handleQueryResults(_args);

    $(document).trigger(that.eventNameSpace + 'sku:set', _args.activeSku);
  };

  /**
    * Method used to delegate the mobile and desktop scenarios if results are passed.
  */
  site.display.prototype.handleQueryResults = function(args) {
    var that = this;
    var _args = args || {};

    $(document).on('DoorsInventory:query:success', $.proxy(function(e, results) {
      if (!results) {
        return null;
      }

      that.data = results;

      that.hasDoors = that.data.sorted.length > 0 ? true : false;
      that.hasInventory = that.checkIfDoorsAvail(that.data.door_inventory);
      //that.hasInventory = true;

      if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
        if (_args.enable_zip) {
          $(document).trigger(that.eventNameSpace + 'loaded:set');
        } else {
          $(document).trigger(that.eventNameSpace + 'loaded:unset');
        }
      }
      if (that.isMobile) {
        $(document).trigger(that.eventNameSpace + 'display:mobile', _args);
      } else {
        $(document).trigger(that.eventNameSpace + 'display:desktop', _args);
      }

      var params = that.data.params ? that.data.params[0] : null;
      var zipCode = params ? params.zip : null;

      var $autoGeoZip = $('.js-auto-geo-zip').html();
      // Update zip code when the akamai_zip is passed in results.
      if (that.data.akamai_zip) {
        zipCode = that.data.akamai_zip.substring(0, 5);
      }
      if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
        zipCode = zipCode ? zipCode : $autoGeoZip;
      }

      // If zip code was either passed with params or akamai_zip, set zip in all panels.
      if (zipCode) {
        $(document).trigger('controls:zip:set:loc', {zip: zipCode});
        $(document).trigger('controls:zip:change', {zip: zipCode});
      }
    }, that));
  };

  /**
    * Method used to handle the mobile display scenarios.
  */
  site.display.prototype.handleMobileDisplay = function(e, args) {
    var that = this;
    var _args = args || {};

    if (that.isLoaded) {
      $(document).trigger(that.eventNameSpace + 'overlay:init', _args);
    } else {
      if (that.hasDoors && that.hasInventory) {
        $(document).trigger(that.eventNameSpace + 'inline:default', _args);
      } else {
        $(document).trigger(that.eventNameSpace + 'inline:edit', _args);
      }
      $(document).trigger(that.eventNameSpace + 'loaded:set');
    }
  };

  /**
    * Method used to handle the desktop display scenarios.
  */
  site.display.prototype.handleDesktopDisplay = function(e, args) {
    var that = this;
    var _args = args || {};

    if (that.isLoaded) {
      // Handle scenarios after user has already seen the intial view.
      if (that.hasDoors && that.hasInventory) {
        $(document).trigger(that.eventNameSpace + 'loaded:set');
        $(document).trigger(that.eventNameSpace + 'inline:stores', _args);
      } else if (!that.hasDoors || !that.hasInventory) {
        $(document).trigger(that.eventNameSpace + 'loaded:set');
        $(document).trigger(that.eventNameSpace + 'inline:stores', _args);
      } else {
        $(document).trigger(that.eventNameSpace + 'error:nodoors', _args);
      }
    } else {
      // Handle scenarios when user first loads the page or display is reset.
      if (that.hasDoors && that.hasInventory) {
        $(document).trigger(that.eventNameSpace + 'loaded:set');
        $(document).trigger(that.eventNameSpace + 'inline:default', _args);
      } else {
        $(document).trigger(that.eventNameSpace + 'inline:edit', _args);
        $(document).trigger(that.eventNameSpace + 'loaded:set');
      }
    }
  };

  /**
    * Initialization method called when the locator is displayed inline.
    * Any class methods that need to be called after the locator is displayed, should be here.
  */
  site.display.prototype.initDefault = function(e, args) {
    var that = this;
    var _args = args || {};

    $(document).trigger('inStoreLocator:state:set', {state: 'init'});
    $(document).trigger(that.eventNameSpace + 'render');
    $(document).trigger('controls:init');
    $(document).trigger(that.eventNameSpace + 'renderDoors', {limit: 1, availOnly: true});
  };

  /**
    * Initialization method called when the locator is displayed inline.
    * Any class methods that need to be called after the locator is displayed, should be here.
  */
  site.display.prototype.initOverlay = function(e, args) {
    var that = this;
    if (args.enableOverlay) {
      that.disableOverlay = false;
    }

    $(document).trigger('inStoreLocator:state:set', {state: 'overlay', setOverlay: true});
    $(document).trigger(this.eventNameSpace + 'overlay:use');
    $(document).trigger(this.eventNameSpace + 'render', {
      template: that.overlayTemplate,
      container: that.dom.$overlayContainer
    });
    $(document).trigger('controls:init:stores:overlay');
    $(document).trigger(this.eventNameSpace + 'renderDoors', {distance: this.distanceVal});

    $(document).trigger(this.eventNameSpace + 'overlay:set');
  };

  site.display.prototype.initEdit = function() {
    $(document).trigger('inStoreLocator:state:set', {state: 'edit'});
    $(document).trigger(this.eventNameSpace + 'render');
    $(document).trigger('controls:init:edit');
    $(document).trigger('doors:clear');
  };

  /**
    * Initialization method called when the locator is inline and the event 'inStoreLocator:opened' is called.
    * 
  */
  site.display.prototype.initStores = function(e, args) {
    var _args = args || {};

    $(document).trigger('inStoreLocator:state:set', {state: 'stores'});
    $(document).trigger(this.eventNameSpace + 'render');
    $(document).trigger('controls:init:stores');
    $(document).trigger(this.eventNameSpace + 'renderDoors', {distance: this.distanceVal});
  };

  /**
    * Method to set the no door display. 
  */
  site.display.prototype.initNoDoors = function(e, args) {
    var that = this;
    var _args = args || {};

    $(document).trigger('inStoreLocator:state:set', {state: 'init'});
    $(document).trigger(that.eventNameSpace + 'render');
    $(document).trigger('controls:init');
    $(document).trigger('controls:displayErrors', { errors: [{ key: 'no_doors_avail'}] });
  };

  /**
    * Method to set the no skus display. 
  */
  site.display.prototype.initNoSkus = function(e, args) {
    var that = this;
    var _args = args || {};

    $(document).trigger('inStoreLocator:state:set', {state: 'init'});
    $(document).trigger(that.eventNameSpace + 'render');
    $(document).trigger('controls:init');
    $(document).trigger('controls:displayErrors', { errors: [{ key: 'no_skus_avail'}] });
  };

  /**
    * Reset method used to reset display to not loaded then pass to mobile or pc display handlers
  */
  site.display.prototype.reset = function(e) {
    $(document).trigger(this.eventNameSpace + 'loaded:unset');
    if (this.isMobile) {
      $(document).trigger(this.eventNameSpace + 'display:mobile');
    } else {
      $(document).trigger(this.eventNameSpace + 'display:desktop');
    }
  };

  /**
    * Method used to open the store check overlay.
  */
  site.display.prototype.openOverlay = function(e, args) {
    if (this.isOverlayOpen) {
      return null;
    }

    var that = this;
    var _args = args || {};
    if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing && that.disableOverlay) {
      return null;
    }

    $(document).trigger('inStoreLocator:state:set', {state: 'overlay', setOverlay: true});

    $('body').append(this.dom.$overlayContainer);

    this.isOverlayOpen = true;
    this.dom.$overlayContainer.css('top', window.screen.height);
    this.dom.$overlayContainer.removeClass('hidden');
    this.dom.$overlayContainer.animate({ top: 0 }, this.animSpeed, this.animType, function() {
      $(document).trigger(that.eventNameSpace + 'overlay:opened');
    });
  };

  /**
    * Method used to close the store check overlay.
  */
  site.display.prototype.closeOverlay = function(e, args) {
    var _args = args || {};
    var that = this;

    this.isOverlayOpen = false;
    this.dom.$overlayContainer.animate({ top: window.screen.height }, this.animSpeed, this.animType, function() {
      that.dom.$overlayContainer.addClass('hidden');
      $(document).trigger(that.eventNameSpace + 'overlay:closed');
    });
  };

  /**
    * Method to render and insert the controls panel to the in-store locator.
    * Uses the template argument passed and if it isn't available, it will use the default.
    * Once the inline template is found, it is placed in a local dom var, for future reference, and then inserted.
  */
  site.display.prototype.render = function(e, args) {
    var _args = args || {};
    var template = _args.template || this.inlineTemplate;
    var _inlineTemplate = $("script.inline-template[path='" + template + "']").html();
    var $storeContainer = $('.js-store-check-inline');

    this.dom.$container = _args.container || $storeContainer || this.dom.$container;
    if (this.dom.$container) {
      this.dom.$container.html(_inlineTemplate);
    }

    this.getNodes();
    //Drupal.behaviors.selectBox.initAll('.js-instore-inv-container')
  };

  /**
    * Method responsible for calling all helper events to only show the door rows in the locator.
    * Similar to renderDoorsWithMap, it uses helper events to show the door rows.
    * Order is specific here so becareful if you need to add or remove events.
  */
  site.display.prototype.renderDoors = function(e, args) {
    var _args = args || {};
    var _limit = _args.limit || null;
    var _distance = _args.distance || null;
    var _hideAvailMsg = _args.hideAvailMsg || null;
    var _availOnly = _args.availOnly || null;
    this.doorData = _args.sorted ? _args.sorted : null;

    $(document).trigger('inStoreLocator:addDoorsStateInline');

    $(document).trigger('doors:renderDoorTable');

    $(document).trigger('doors:renderTableRows', {
      limit: _limit,
      distance: _distance,
      hideAvailMsg: _hideAvailMsg,
      availOnly: _availOnly,
      callback: function(args) {
        $(document).trigger('doors:setDoorEventsInline', args);
      }
    });
  };

  /**
    * Helper method responsible checking the door_inventory object that gets returned in results.
    * Traverses through the object to determine if a door has available skus or not.
  */
  //auto geolocation for Aveda purpose
  site.display.prototype.checkIfDoorsAvail = function(doors) {
    if (!doors) {
      return false;
    }

    function checkSkusOnHand(skus) {
      var areSkusAvail = false;
      for (var skuId in skus) {
        if (skus[skuId] && skus[skuId].is_available) {
          areSkusAvail = true;
        }
      }
      return areSkusAvail;
    }

    var isAvail = false;
    for (var doorId in doors) {
      var door = doors[doorId];
      if (door && door.skus_onhand) {
        if (checkSkusOnHand(door.skus_onhand)) {
          isAvail = true;
        }
      }
    }

    return isAvail;
  };

  /**
    * Method that handles changes when the product sku is changed on the page.
    * When the sku is changed, it sets the display to the single product display.
  */
  site.display.prototype.onSkuChange = function(e, sku) {
    if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
      var $zipInput = $('.js-zip-input');
      $(document).trigger('controls:hideErrors');
      $zipInput.val('');
    }
    this.activeSku = sku;
  };

  /**
    * Method that handles changes when the distance drop down is changed.
    * Updates the glabal this.distanceVal with whatever the value is for the distance select menu. 
  */
  site.display.prototype.setDist = function(e, dist) {
    this.distanceVal = dist;
  };

  /**
    * Method used to set the global useOverlay flag to true.
  */
  site.display.prototype.setOverlayFlag = function() {
    this.useOverlay = true;
  };

  /**
    * Method used to set the current state of the app.
    * Listens in on the 'display:state:set' event.
  */
  site.display.prototype.setState = function(e, state) {
    this.state = state;
  };

  /**
    * Method used to set the global isLoaded flag.
    * isLoaded is used to determine if the user has loaded the app.
    * In certain scenarios, the initial load needs to be handle differently then subsequent actions.
  */
  site.display.prototype.setLoaded = function() {
    this.isLoaded = true;
  };

  /**
    * Method used to unset the global isLoaded flag.
  */
  site.display.prototype.unsetLoaded = function() {
    this.isLoaded = false;
  };

  /**
    * Method used to set the global isMobile flag.
  */
  site.display.prototype.setMobileFlag = function(e, isMobile) {
    this.isMobile = isMobile;
  };

  /**
    * Method to unbind all events associated to document.
    * Calls the inStoreLocator event removeEvents passing the current namespace.
  */
  site.display.prototype.removeEvents = function(e) {
    var that = this;
    $(document).trigger('inStoreLocator:removeEvents', {
      nameSpace: that.eventNameSpace
    });
  };
})(jQuery);
